// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Tnqu","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1sMIb"};